import "../css/styles.css";
import "../css/QueueStatusIndicator.css";

import { useEffect, useState } from "react";

import { useMessageUpdate } from "../context/MessageContext";
import { usePresentationUpdate } from "../context/PresentationContext";


export default function QueueStatusIndicator() {

  const messageUpdate = useMessageUpdate();
  const presentationUpdate = usePresentationUpdate();

  const [ messageQueueCount, setMessageQueueCount ] = useState<number>( 0 );
  const [ taskQueueCount, setTaskQueueCount ] = useState<number>( 0 );
  const [ isProcessing, setIsProcessing ] = useState<boolean>( false );
  const [ nextTaskTime, setNextTaskTime ] = useState<number | null>( null );
  const [ timeRemaining, setTimeRemaining ] = useState<number>( 0 );


  useEffect( () => {
    const intervalId = setInterval( () => {
      const msgCount = messageUpdate?.getMessageQueueLength ? messageUpdate.getMessageQueueLength() : 0;
      const immediateTaskCount = presentationUpdate?.getImmediateTaskCount ? presentationUpdate.getImmediateTaskCount() : 0;
      const processingMsg = messageUpdate?.getIsProcessingMessage ? messageUpdate.getIsProcessingMessage() : false;
      const processingTask = presentationUpdate?.getIsProcessingTasks ? presentationUpdate.getIsProcessingTasks() : false;
      const nextScheduledTime = presentationUpdate?.getNextScheduledTaskTime ? presentationUpdate.getNextScheduledTaskTime() : null;

      setMessageQueueCount( msgCount );
      setTaskQueueCount( immediateTaskCount );
      setIsProcessing( processingMsg || processingTask );
      setNextTaskTime( nextScheduledTime );

      if( nextScheduledTime ) {
        const remaining = Math.max( 0, nextScheduledTime - Date.now() );
        setTimeRemaining( remaining );
      } else {
        setTimeRemaining( 0 );
      }
    }, 500 );

    return () => clearInterval( intervalId );
  }, [messageUpdate, presentationUpdate]);


  const formatTimeRemaining = ( milliseconds: number ): string => {
    const totalSeconds = Math.ceil( milliseconds / 1000 );
    const minutes = Math.floor( totalSeconds / 60 );
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const totalQueueCount = messageQueueCount + taskQueueCount;
  const hasScheduledTask = nextTaskTime !== null && timeRemaining > 0;
  const hasActiveContent = totalQueueCount > 0 || isProcessing || hasScheduledTask;

  if( !hasActiveContent ) {
    return null;
  }

  const getStatusMessage = (): string => {
    if( isProcessing && totalQueueCount === 0 && !hasScheduledTask ) {
      return "Processing...";
    }
    
    if( totalQueueCount > 0 ) {
      return `${totalQueueCount} chunk${totalQueueCount !== 1 ? 's' : ''} remaining`;
    }
    
    if( hasScheduledTask ) {
      return `Slide continues in ${formatTimeRemaining( timeRemaining )}`;
    }
    
    return "Processing...";
  };

  return (
    <div className="queue-status-indicator">
      <div className="queue-pulse-dot"></div>
      <span className="queue-status-text">
        {getStatusMessage()}
      </span>
    </div>
  );
}